import { useEffect, useState } from 'react';

/**
 * A `Date.now()` that advances every `intervalMs`, for re-rendering
 * time-based UI (relative durations, ageing state) without a network request.
 * `intervalMs <= 0` freezes it at its initial value.
 */
const useTicker = (intervalMs: number): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (intervalMs <= 0) {
      return undefined;
    }
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
};

export default useTicker;
